var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 300,
    viewBox: "0 0 1400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3651_16080)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 300,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.45 -110.487H-2.5V393.777H1403.45V-110.487Z",
    fill: "url(#paint0_radial_3651_16080)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.45 -110.486H-2.5V393.778H1403.45V-110.486Z",
    fill: "url(#paint1_radial_3651_16080)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1421 149.65L1377.96 128.814L1421 94.8212V93.0703L1375.41 129.089L1421 151.176V149.65Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1421 93.0709L1378.39 126.739L1412.06 48.2474L1421 51.4741V50.0233L1411.94 46.7466L1411.31 46.5215L1375.01 131.141L1421 94.8218V93.0709Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1190.86 -32.4458L1192.36 53.3742L1180.42 43.394L1181.29 42.3434L1190.96 50.4227L1189.63 -24.5917L1179.74 38.2163L1178.39 37.9911L1189.5 -32.5459L1190.86 -32.4458Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1182.14 38.4419C1181.87 40.1177 1180.29 41.2684 1178.61 41.0182C1176.94 40.7431 1175.79 39.1672 1176.04 37.4914C1176.31 35.8155 1177.89 34.6649 1179.57 34.915C1181.24 35.1651 1182.39 36.741 1182.14 38.4419Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1182.94 40.6172C1181.64 39.5167 1179.69 39.6918 1178.59 40.9924C1177.49 42.2931 1177.66 44.2442 1178.96 45.3197C1180.27 46.4203 1182.22 46.2452 1183.32 44.9445C1184.42 43.6438 1184.27 41.6928 1182.94 40.6172Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1421 151.175V149.65L1376.99 128.338L1376.31 127.988L1345.82 216.235L1347.1 216.685L1377.09 129.889L1421 151.175Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1421 182.768L1347.85 217.336L1348.45 218.586L1421 184.293V182.768Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1349.6 220.688C1348.07 221.413 1346.22 220.763 1345.5 219.212C1344.77 217.686 1345.42 215.835 1346.97 215.11C1348.5 214.384 1350.35 215.035 1351.08 216.585C1351.8 218.111 1351.15 219.962 1349.6 220.688Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1343.59 215.309C1343.04 216.91 1343.89 218.661 1345.5 219.236C1347.1 219.787 1348.85 218.936 1349.43 217.335C1349.98 215.735 1349.13 213.984 1347.52 213.408C1345.9 212.833 1344.14 213.684 1343.59 215.309Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1363.8 -36.4971L1412.54 47.497L1412.16 47.8722L1313.3 145.774L1360.34 -36.0218L1361.67 -35.6716L1315.88 141.296L1410.84 47.2719L1362.62 -35.7967L1363.8 -36.4971Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1361.67 -35.6723L1315 144.672L1190.38 51.7987L1358.84 -37.8984L1359.46 -36.6978L1192.93 51.9988L1314.18 142.371L1360.34 -36.0225L1361.67 -35.6723Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1316.65 143.721L1201.7 172.486L1197.59 93.4948L1198.97 93.4197L1203 170.76L1312.52 143.346L1200.52 92.3942L1201.07 91.1436L1316.65 143.721Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1199.67 94.6205C1198.12 93.9201 1197.44 92.0941 1198.14 90.5433C1198.84 88.9925 1200.67 88.3171 1202.22 89.0175C1203.78 89.7179 1204.45 91.5438 1203.75 93.0947C1203.05 94.6455 1201.22 95.3208 1199.67 94.6205Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1201.37 93.4697C1201.27 91.7688 1199.84 90.4681 1198.14 90.5431C1196.44 90.6432 1195.14 92.0689 1195.21 93.7698C1195.31 95.4707 1196.74 96.7714 1198.44 96.6964C1200.14 96.6213 1201.47 95.1706 1201.37 93.4697Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1320.11 146.798L1200.52 92.3947L1201.07 91.1441L1309.07 140.27L1192.61 53.4743L1198.32 87.5422L1196.97 87.7673L1190.71 50.3477L1320.11 146.798Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M1199.67 94.6205C1198.12 93.9201 1197.44 92.0941 1198.14 90.5433C1198.84 88.9925 1200.67 88.3171 1202.22 89.0175C1203.78 89.7179 1204.45 91.5438 1203.75 93.0947C1203.05 94.6455 1201.22 95.3208 1199.67 94.6205Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1194.59 88.0181C1194.86 89.6939 1196.46 90.8195 1198.14 90.5444C1199.82 90.2692 1200.95 88.6684 1200.67 86.9925C1200.39 85.3166 1198.79 84.191 1197.11 84.4662C1195.44 84.7413 1194.31 86.3422 1194.59 88.0181Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1314.43 142.871L1314.85 144.147L1212.91 188.52L1212.36 187.269L1306.74 146.198L1203.3 172.086L1209.41 186.094L1208.15 186.644L1201.39 171.161L1202.17 170.961L1314.43 142.871Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1214.01 190.647C1212.46 191.322 1210.63 190.622 1209.96 189.046C1209.28 187.495 1209.98 185.669 1211.56 184.994C1213.11 184.319 1214.94 185.019 1215.61 186.595C1216.26 188.146 1215.56 189.972 1214.01 190.647Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1205.87 187.47C1206.55 189.021 1208.38 189.746 1209.93 189.071C1211.48 188.396 1212.21 186.57 1211.53 185.019C1210.86 183.468 1209.03 182.743 1207.48 183.418C1205.92 184.093 1205.2 185.894 1205.87 187.47Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1192.08 50.3223L1198.32 87.5418L1196.96 87.7669L1191.23 53.4739L1178.91 68.1816L1196.69 87.917L1195.66 88.8175L1177.11 68.2066L1192.08 50.3223Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1200.67 86.9925C1200.95 88.6684 1199.82 90.2692 1198.14 90.5444C1196.46 90.8195 1194.86 89.6939 1194.59 88.0181C1194.31 86.3422 1195.44 84.7413 1197.11 84.4662C1198.79 84.191 1200.39 85.3166 1200.67 86.9925Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1193.78 90.3187C1194.91 91.5944 1196.86 91.6944 1198.14 90.5438C1199.42 89.4182 1199.52 87.4672 1198.37 86.1915C1197.21 84.9159 1195.29 84.8158 1194.01 85.9664C1192.73 87.092 1192.63 89.043 1193.78 90.3187Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1192.64 51.8228L1180.42 66.4055L1179.37 65.53L1190.71 51.9979L1179.27 42.4429L1178.77 65.2799L1177.41 65.2549L1177.96 39.5664L1192.64 51.8228Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M1182.37 67.8074C1181.27 69.1081 1179.34 69.2832 1178.04 68.1826C1176.74 67.082 1176.56 65.156 1177.66 63.8303C1178.77 62.5296 1180.69 62.3546 1182 63.4551C1183.27 64.5557 1183.45 66.5067 1182.37 67.8074Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1175.01 65.0557C1174.99 66.7566 1176.31 68.1573 1178.01 68.2073C1179.72 68.2573 1181.12 66.9066 1181.17 65.2057C1181.19 63.5048 1179.87 62.1041 1178.16 62.0541C1176.46 62.0041 1175.04 63.3548 1175.01 65.0557Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1359.92 -41.0751L1359.04 -40.0246L1319.36 -73.192L1195.49 49.0972L1358.84 -37.8985L1359.46 -36.6978L1187.85 54.7002L1319.28 -75.043L1359.92 -41.0751Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1321.84 -75.6436L1194.24 50.3226L1193.26 49.3721L1316.81 -72.592L1190.86 -31.9456L1192.28 48.9719L1190.93 48.9969L1189.48 -32.9461L1189.96 -33.0962L1321.84 -75.6436Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1194.69 48.772C1194.71 50.4729 1193.36 51.8737 1191.66 51.8987C1189.96 51.9237 1188.55 50.573 1188.53 48.8721C1188.5 47.1712 1189.86 45.7705 1191.56 45.7455C1193.26 45.7204 1194.66 47.0712 1194.69 48.772Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M1191.68 47.5463C1190.48 48.7469 1190.46 50.6979 1191.66 51.8986C1192.86 53.0992 1194.81 53.1242 1196.01 51.9236C1197.22 50.7229 1197.24 48.7719 1196.04 47.5713C1194.86 46.3706 1192.91 46.3456 1191.68 47.5463Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1421 39.9429L1411.91 46.3963L1363.22 -37.4978L1421 -19.0131V-20.4638L1361.94 -39.3237L1360.24 -39.874L1411.11 47.722L1411.49 48.3723L1421 41.6188V39.9429Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1421 321.315L1364.9 251.579L1421 254.555V253.179L1361.92 250.053L1421 323.491V321.315Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1179.32 40.493L1178.76 65.281L1177.41 65.256L1177.91 41.4935L1149.57 32.9891L1176.66 65.5061L1175.61 66.3816L1145.59 30.3877L1179.32 40.493Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1181.17 65.1813C1181.14 66.8822 1179.72 68.2329 1178.01 68.1829C1176.31 68.1329 1174.96 66.7321 1175.01 65.0312C1175.03 63.3303 1176.46 61.9796 1178.16 62.0297C1179.87 62.0797 1181.22 63.4804 1181.17 65.1813Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1173.68 67.8067C1174.78 69.1074 1176.71 69.2825 1178.01 68.2069C1179.31 67.1063 1179.49 65.1803 1178.41 63.8796C1177.31 62.5789 1175.38 62.4038 1174.08 63.4794C1172.76 64.555 1172.58 66.506 1173.68 67.8067Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1191.33 -35.4219L1179.16 41.8687L1150.2 33.1891L1150.57 31.8885L1178.06 40.1178L1189 -29.4687L1149.77 29.6373L1148.62 28.8869L1191.33 -35.4219Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1149.65 35.5394C1148.02 35.0391 1147.09 33.3383 1147.57 31.7124C1148.07 30.0866 1149.77 29.1611 1151.4 29.6363C1153.03 30.1366 1153.95 31.8375 1153.48 33.4633C1153 35.0892 1151.28 36.0147 1149.65 35.5394Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1146.72 27.411C1145.77 28.8367 1146.17 30.7377 1147.6 31.6882C1149.02 32.6387 1150.93 32.2385 1151.88 30.8127C1152.83 29.387 1152.43 27.486 1151 26.5355C1149.57 25.61 1147.67 26.0102 1146.72 27.411Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1182.57 -51.5801L1190.96 -32.37L1190.76 -32.0698L1149.78 29.6376L1148.97 29.1123L1148.12 28.7371L1182.57 -51.5801ZM1189.41 -32.5201L1182.6 -48.1533L1151.2 25.0351L1189.41 -32.5201Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1151.85 30.8377C1150.9 32.2635 1149 32.6387 1147.57 31.7132C1146.14 30.7627 1145.77 28.8617 1146.7 27.4359C1147.65 26.0102 1149.55 25.635 1150.98 26.5605C1152.4 27.511 1152.8 29.412 1151.85 30.8377Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1145.97 27.6357C1145.29 29.2116 1146.02 31.0125 1147.6 31.6879C1149.17 32.3632 1150.98 31.6378 1151.65 30.062C1152.33 28.4862 1151.6 26.6853 1150.03 26.0099C1148.45 25.3596 1146.65 26.0849 1145.97 27.6357Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1183.6 -50.4804L1149.37 29.2615L1148.12 28.7362L1181.57 -49.2547L1089.72 -55.7832L1146.52 28.8863L1145.39 29.6367L1087.04 -57.334L1183.6 -50.4804Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1151.63 30.087C1150.95 31.6629 1149.15 32.3632 1147.57 31.7129C1146.02 31.0375 1145.29 29.2366 1145.94 27.6608C1146.59 26.0849 1148.42 25.3846 1150 26.0349C1151.58 26.7103 1152.3 28.5112 1151.63 30.087Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1143.31 30.8373C1144.27 32.238 1146.17 32.6382 1147.6 31.6877C1149.02 30.7372 1149.4 28.8362 1148.45 27.4105C1147.49 26.0098 1145.59 25.6095 1144.17 26.56C1142.74 27.5105 1142.36 29.4366 1143.31 30.8373Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M1345.2 137.369L1346.2 219.988L1317.86 216.886L1317.99 215.535L1344.8 218.462L1343.9 144.348L1316.71 213.434L1315.46 212.934L1345.2 137.369Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M1319.01 214.159C1318.38 215.735 1316.6 216.51 1315 215.91C1313.43 215.285 1312.65 213.509 1313.25 211.908C1313.88 210.332 1315.65 209.557 1317.26 210.157C1318.86 210.782 1319.63 212.583 1319.01 214.159Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1318.41 213.183C1316.71 213.008 1315.21 214.208 1315 215.909C1314.83 217.61 1316.06 219.111 1317.73 219.311C1319.44 219.486 1320.94 218.286 1321.14 216.585C1321.31 214.884 1320.11 213.358 1318.41 213.183Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1377.82 127.813L1347.1 216.685L1345.97 216.285L1344.77 216.31L1343.84 140.395L1344.29 140.22L1377.82 127.813ZM1346.15 215.284L1375.59 130.09L1345.25 141.346L1346.15 215.284Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1349.43 217.31C1348.88 218.911 1347.12 219.762 1345.5 219.211C1343.89 218.661 1343.04 216.91 1343.59 215.284C1344.14 213.683 1345.9 212.833 1347.52 213.383C1349.13 213.959 1349.98 215.709 1349.43 217.31Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1342.37 216.184C1342.39 217.885 1343.79 219.236 1345.5 219.236C1347.2 219.211 1348.55 217.81 1348.55 216.109C1348.53 214.408 1347.12 213.058 1345.42 213.058C1343.72 213.083 1342.37 214.483 1342.37 216.184Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1345.59 140.095L1316.73 213.433L1315.58 212.983H1314.33L1313.93 142.921L1345.59 140.095ZM1315.65 212.358L1343.49 141.646L1315.25 144.172L1315.65 212.358Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1318.08 212.809C1318.08 214.51 1316.73 215.885 1315.03 215.91C1313.32 215.91 1311.95 214.56 1311.92 212.859C1311.9 211.158 1313.27 209.757 1314.98 209.757C1316.68 209.732 1318.06 211.108 1318.08 212.809Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1313.28 211.907C1312.65 213.483 1313.43 215.284 1315.03 215.91C1316.6 216.535 1318.41 215.759 1319.03 214.159C1319.66 212.583 1318.88 210.782 1317.28 210.156C1315.68 209.531 1313.88 210.332 1313.28 211.907Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1414.79 41.8936L1378.49 126.513L1377.21 125.988L1408.61 52.8743L1346.4 139.445L1373.71 129.314L1374.19 130.59L1342.69 142.271L1414.79 41.8936Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1374.88 132.916C1376.49 132.316 1377.29 130.54 1376.71 128.964C1376.11 127.363 1374.33 126.563 1372.76 127.138C1371.15 127.739 1370.35 129.514 1370.93 131.09C1371.5 132.691 1373.28 133.492 1374.88 132.916Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M1410.54 50.1469L1344.92 141.495L1312.75 144.346L1314.1 143.021L1409.13 48.9463L1409.78 49.5966L1410.54 50.1469ZM1344.17 140.219L1406.38 53.6238L1316.4 142.696L1344.17 140.219Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1421 189.296V187.695L1354.68 228.542L1355.41 229.692L1421 189.296Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1421 251.528L1355.56 230.893L1355.16 232.193L1421 252.979V251.528Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1354.56 234.52C1352.93 234.02 1352.03 232.269 1352.55 230.643C1353.05 229.017 1354.81 228.117 1356.43 228.642C1358.06 229.142 1358.96 230.893 1358.44 232.519C1357.93 234.145 1356.18 235.045 1354.56 234.52Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1353.56 226.415C1352.1 227.316 1351.65 229.217 1352.55 230.668C1353.46 232.118 1355.36 232.569 1356.81 231.668C1358.26 230.768 1358.71 228.867 1357.81 227.416C1356.91 225.965 1355.01 225.515 1353.56 226.415Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1421 251.528L1355.56 230.893L1355.16 232.193L1421 252.954V251.528Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1421 253.179L1363.85 250.152L1354.56 232.918L1353.33 233.568L1363 251.478L1421 254.554V253.179Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1354.56 234.52C1352.93 234.02 1352.03 232.269 1352.55 230.643C1353.05 229.017 1354.81 228.117 1356.43 228.642C1358.06 229.142 1358.96 230.893 1358.44 232.519C1357.93 234.145 1356.18 235.045 1354.56 234.52Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1356.74 231.918C1355.94 230.418 1354.06 229.867 1352.56 230.668C1351.05 231.468 1350.5 233.344 1351.3 234.845C1352.11 236.346 1353.98 236.896 1355.49 236.096C1356.99 235.27 1357.54 233.419 1356.74 231.918Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1356.81 231.668C1355.36 232.569 1353.46 232.118 1352.55 230.668C1351.65 229.217 1352.1 227.316 1353.56 226.415C1355.01 225.515 1356.91 225.965 1357.79 227.416C1358.69 228.867 1358.24 230.768 1356.81 231.668Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1348.32 229.643C1349.23 231.093 1351.13 231.544 1352.56 230.643C1354.01 229.743 1354.46 227.842 1353.56 226.416C1352.66 224.965 1350.75 224.515 1349.3 225.415C1347.87 226.316 1347.42 228.192 1348.32 229.643Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1315.25 141.671L1315.28 143.522L1315.68 212.958L1314.3 212.983L1313.9 145.398L1245.36 227.291L1312 215.735L1312.22 217.06L1241.93 229.292L1315.25 141.671Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1318.08 212.809C1318.08 214.51 1316.73 215.885 1315.03 215.91C1313.32 215.91 1311.95 214.56 1311.92 212.859C1311.9 211.158 1313.27 209.757 1314.98 209.757C1316.68 209.732 1318.06 211.108 1318.08 212.809Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1312.5 219.462C1314.18 219.162 1315.31 217.586 1315.01 215.91C1314.7 214.234 1313.13 213.109 1311.45 213.409C1309.77 213.709 1308.65 215.285 1308.95 216.961C1309.22 218.637 1310.82 219.762 1312.5 219.462Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1316.95 141.745L1246.03 226.49L1245 225.614L1312.2 145.322L1211.06 189.32L1242.25 225.614L1241.22 226.515L1208.83 188.795L1209.65 188.42L1316.95 141.745Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1247.99 227.916C1246.89 229.217 1244.96 229.392 1243.66 228.291C1242.35 227.19 1242.18 225.264 1243.28 223.939C1244.38 222.638 1246.31 222.463 1247.64 223.564C1248.91 224.664 1249.09 226.59 1247.99 227.916Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1239.3 227.967C1240.4 229.267 1242.35 229.417 1243.66 228.292C1244.96 227.191 1245.11 225.24 1243.98 223.94C1242.88 222.639 1240.93 222.489 1239.63 223.614C1238.32 224.715 1238.17 226.666 1239.3 227.967Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1421 16.6299L1409.08 30.3621L1359.46 -99.1559L1421 -70.3407V-72.4418L1356.01 -102.883L1407.88 32.5133L1408.43 33.964L1421 19.5315V16.6299Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1357.89 -103.258L1358.62 -101.357L1408.18 28.0361L1406.43 28.7115L1357.56 -98.7805L1288.97 24.3092L1404.75 30.9877L1404.65 32.8636L1285.84 26.0101L1357.89 -103.258Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1353.63 -101.781L1353.73 -99.8803L1289.72 -96.9287L1288.39 21.4334L1354.93 -97.9292L1356.59 -97.0037L1286.41 28.8873L1287.87 -98.7547L1288.74 -98.7797L1353.63 -101.781Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M963.617 -82.6973L1011.23 26.385L990.629 19.9566L991.18 18.1557L1007.85 23.3334L966.221 -71.9666L986.999 13.6783L985.147 14.1286L961.814 -82.097L963.617 -82.6973Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M990.177 12.678C990.728 14.9792 989.326 17.2804 987.023 17.8307C984.72 18.381 982.416 16.9803 981.866 14.6791C981.315 12.3779 982.717 10.0767 985.02 9.52637C987.298 8.97608 989.627 10.4018 990.177 12.678Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M992.382 15.0294C990.129 14.329 987.726 15.5797 987.025 17.8309C986.324 20.0821 987.575 22.4833 989.829 23.1837C992.082 23.8841 994.485 22.6334 995.186 20.3822C995.887 18.131 994.635 15.7298 992.382 15.0294Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1410.78 31.3379L1298.95 154.928L1297.55 153.652L1406.73 32.9888L1288.41 26.1602L1296.23 153.177L1294.32 153.302L1286.39 24.1592L1287.46 24.2092L1410.78 31.3379Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1301.56 157.004C1299.98 158.755 1297.28 158.88 1295.52 157.304C1293.77 155.728 1293.65 153.027 1295.22 151.276C1296.8 149.525 1299.51 149.4 1301.26 150.976C1303.01 152.551 1303.14 155.253 1301.56 157.004Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1290.99 153.302C1291.14 155.653 1293.17 157.454 1295.52 157.304C1297.88 157.154 1299.68 155.128 1299.53 152.776C1299.38 150.425 1297.35 148.624 1295 148.774C1292.65 148.924 1290.84 150.951 1290.99 153.302Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1260.75 -118.016L1287.64 -97.5299L1216.12 73.2848L1188.98 -118.016H1187.08L1215.22 80.3635L1289.67 -97.4798L1289.94 -98.1552L1263.88 -118.016H1260.75Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1187.08 -118.016L1214.54 75.561L1011.21 24.3091L1128.15 -118.016H1125.69L1007.85 25.4097L1216.79 78.0873L1188.98 -118.016H1187.08Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1218.4 75.9861L1086.59 173.888L1039.3 74.9606L1041 74.1351L1087.31 171.011L1212.94 77.687L1042.43 71.984L1042.48 70.083L1218.4 75.9861Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1042.53 75.31C1040.17 75.235 1038.32 73.2589 1038.39 70.9077C1038.47 68.5565 1040.45 66.7055 1042.8 66.7805C1045.15 66.8556 1047.01 68.8316 1046.93 71.1828C1046.86 73.5341 1044.88 75.3851 1042.53 75.31Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1044.08 72.9093C1043.05 70.7831 1040.5 69.8827 1038.37 70.9082C1036.24 71.9337 1035.34 74.4851 1036.37 76.6112C1037.39 78.7373 1039.95 79.6378 1042.08 78.6123C1044.2 77.5867 1045.1 75.0354 1044.08 72.9093Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1224.45 78.0871L1042.43 71.9839L1042.48 70.0829L1206.88 75.5858L1011.58 26.36L1037.04 66.9563L1035.44 67.9568L1007.48 23.3584L1224.45 78.0871Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M1042.53 75.31C1040.17 75.235 1038.32 73.2589 1038.39 70.9077C1038.47 68.5565 1040.45 66.7055 1042.8 66.7805C1045.15 66.8556 1047.01 68.8316 1046.93 71.1828C1046.86 73.5341 1044.88 75.3851 1042.53 75.31Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1032.49 69.5324C1033.74 71.5334 1036.37 72.1337 1038.37 70.8831C1040.37 69.6324 1040.97 67.006 1039.72 65.005C1038.47 63.0039 1035.84 62.4036 1033.84 63.6543C1031.86 64.9049 1031.23 67.5313 1032.49 69.5324Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1215.09 76.0859L1216.34 77.4867L1109.44 188.445L1108.09 187.144L1207.05 84.4153L1088.41 172.537L1103.68 187.219L1102.36 188.595L1085.48 172.361L1086.39 171.686L1215.09 76.0859Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1112 190.596C1110.37 192.297 1107.64 192.347 1105.96 190.721C1104.26 189.095 1104.21 186.394 1105.84 184.693C1107.47 182.992 1110.2 182.942 1111.87 184.568C1113.57 186.194 1113.63 188.895 1112 190.596Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1099.91 190.847C1101.61 192.473 1104.31 192.423 1105.94 190.722C1107.57 189.021 1107.52 186.32 1105.81 184.694C1104.11 183.068 1101.41 183.118 1099.78 184.819C1098.15 186.52 1098.2 189.196 1099.91 190.847Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1009.26 22.6084L1037.04 66.9567L1035.44 67.9572L1009.83 27.1108L1001.89 52.4741L1035.14 68.3074L1034.31 70.0083L999.592 53.4746L1009.26 22.6084Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1039.75 65.005C1041 67.006 1040.4 69.6324 1038.4 70.8831C1036.39 72.1337 1033.76 71.5334 1032.51 69.5324C1031.26 67.5313 1031.86 64.9049 1033.86 63.6543C1035.84 62.4036 1038.5 63.0039 1039.75 65.005Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1032.69 72.9099C1034.81 73.9354 1037.37 73.0099 1038.39 70.8838C1039.42 68.7577 1038.49 66.2063 1036.37 65.1808C1034.24 64.1553 1031.68 65.0807 1030.66 67.2069C1029.66 69.358 1030.56 71.9093 1032.69 72.9099Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1010.73 24.2346L1002.87 49.3978L1001.07 48.8225L1008.35 25.4853L988.626 19.332L1000.17 48.8475L998.39 49.5479L985.422 16.3555L1010.73 24.2346Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M1006.1 50.1723C1005.4 52.4234 1003 53.6741 1000.74 52.9737C998.491 52.2734 997.24 49.8721 997.941 47.6209C998.642 45.3697 1001.04 44.1191 1003.3 44.8195C1005.55 45.5198 1006.8 47.9211 1006.1 50.1723Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M995.211 50.5473C996.062 52.7485 998.541 53.824 1000.74 52.9736C1002.95 52.1232 1004.02 49.6469 1003.17 47.4457C1002.32 45.2445 999.843 44.169 997.639 45.0194C995.436 45.8699 994.36 48.3462 995.211 50.5473Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1125.69 -118.016L1012.93 19.2564L1070.64 -118.016H1068.56L1006.15 30.4873L1128.14 -118.016H1125.69Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1068.59 -118.016L1010.23 20.7572L1011.98 21.4826L1070.64 -118.016H1068.59Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1006.1 -118.016H1003.17L962.116 -83.0473L961.59 -82.572L1007.05 21.5326L1008.78 20.7572L963.893 -82.0467L1006.1 -118.016Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1011.76 19.2319C1012.71 21.383 1011.71 23.9093 1009.56 24.8598C1007.4 25.8103 1004.87 24.8098 1003.92 22.6587C1002.97 20.5076 1003.97 17.9812 1006.13 17.0307C1008.28 16.0802 1010.81 17.0808 1011.76 19.2319Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M1007.25 19.2811C1006.33 21.4572 1007.35 23.9585 1009.53 24.884C1011.71 25.8095 1014.21 24.784 1015.14 22.6078C1016.07 20.4317 1015.04 17.9304 1012.86 17.0049C1010.68 16.0794 1008.18 17.1049 1007.25 19.2811Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1421 233.944L1337.58 188.395L1418.15 159.855L1421 165.833V161.431L1419.12 157.504L1332.95 188.02L1421 236.095V233.944Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M987.648 16.8301L1000.17 48.8469L998.388 49.5472L986.396 18.8561L945.59 23.0333L997.587 50.2726L996.711 51.9485L939.131 21.8077L987.648 16.8301Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1003.17 47.4457C1004.02 49.6469 1002.95 52.1232 1000.74 52.9736C998.541 53.824 996.062 52.7485 995.211 50.5473C994.36 48.3462 995.436 45.8699 997.639 45.0194C999.843 44.169 1002.32 45.2445 1003.17 47.4457Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M994.984 54.7751C997.087 55.8756 999.666 55.0752 1000.74 52.9741C1001.84 50.873 1001.04 48.2966 998.94 47.2211C996.837 46.1205 994.258 46.9209 993.181 49.022C992.08 51.0981 992.881 53.6995 994.984 54.7751Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M962.639 -86.749L988.2 18.6813L946.492 22.9335L946.292 21.0576L985.846 17.0054L962.84 -77.8694L944.063 18.6063L942.211 18.2561L962.639 -86.749Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M947.042 26.235C944.688 26.4851 942.585 24.7592 942.36 22.433C942.11 20.0818 943.837 17.9807 946.165 17.7556C948.519 17.5054 950.622 19.2313 950.847 21.5576C951.097 23.8838 949.395 25.9849 947.042 26.235Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M938.982 17.4058C938.532 19.732 940.034 21.9582 942.362 22.4084C944.69 22.8586 946.918 21.3579 947.369 19.0316C947.819 16.7054 946.317 14.4792 943.989 14.029C941.661 13.5788 939.433 15.1046 938.982 17.4058Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M942.813 -102.782L963.767 -82.6467L963.667 -82.1464L944.064 18.6065L942.763 18.3564L941.461 18.3314L942.813 -102.782ZM961.714 -81.9963L944.665 -98.3799L943.439 12.003L961.714 -81.9963Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M947.369 19.0316C946.918 21.3578 944.665 22.8586 942.362 22.4084C940.034 21.9581 938.532 19.7069 938.982 17.4057C939.433 15.0795 941.686 13.5787 943.989 14.029C946.292 14.4792 947.819 16.7304 947.369 19.0316Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M938.131 18.1054C938.106 20.4566 940.009 22.4077 942.362 22.4327C944.715 22.4577 946.668 20.5567 946.693 18.2054C946.718 15.8542 944.815 13.9032 942.462 13.8782C940.084 13.8532 938.156 15.7291 938.131 18.1054Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M944.689 -101.907L943.337 18.3809L941.46 18.3559L942.786 -99.2558L821.718 -58.8096L939.507 19.3815L938.455 20.9573L817.438 -59.3599L944.689 -101.907Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M946.668 18.2054C946.643 20.5567 944.715 22.4577 942.337 22.4327C939.983 22.4077 938.081 20.4816 938.106 18.1054C938.131 15.7542 940.058 13.8532 942.437 13.8782C944.815 13.9032 946.718 15.8292 946.668 18.2054Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M936.428 23.6092C938.406 24.9098 941.06 24.3846 942.361 22.4085C943.663 20.4325 943.137 17.7811 941.16 16.4804C939.182 15.1797 936.528 15.705 935.227 17.681C933.925 19.6571 934.476 22.3085 936.428 23.6092Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M1251.57 52.6738L1296.83 157.904L1258.9 169.01L1258.35 167.209L1294.23 156.678L1253.64 62.3039L1255.6 165.183L1253.69 165.208L1251.57 52.6738Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M1258.92 164.908C1258.97 167.259 1257.1 169.21 1254.74 169.26C1252.39 169.31 1250.44 167.434 1250.39 165.083C1250.34 162.732 1252.22 160.78 1254.57 160.73C1256.92 160.68 1258.87 162.556 1258.92 164.908Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1257.62 163.958C1255.37 164.633 1254.07 166.984 1254.72 169.261C1255.39 171.512 1257.75 172.812 1260.03 172.162C1262.28 171.487 1263.58 169.135 1262.93 166.859C1262.28 164.583 1259.9 163.282 1257.62 163.958Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1288.24 23.1084L1296.23 153.202L1294.58 153.302L1293.05 153.952L1251.47 57.2763L1251.97 56.8261L1288.24 23.1084ZM1294.25 151.926L1286.59 27.2106L1253.75 57.7266L1294.25 151.926Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1299.53 152.776C1299.68 155.128 1297.88 157.154 1295.52 157.304C1293.17 157.454 1291.14 155.653 1290.99 153.302C1290.84 150.951 1292.65 148.924 1295 148.774C1297.35 148.624 1299.38 150.425 1299.53 152.776Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1289.92 155.053C1290.84 157.229 1293.37 158.23 1295.53 157.279C1297.7 156.354 1298.71 153.828 1297.75 151.676C1296.83 149.5 1294.3 148.5 1292.15 149.45C1289.99 150.376 1288.97 152.902 1289.92 155.053Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1253.52 55.9512L1255.59 165.184L1253.87 165.209L1252.26 165.884L1214.46 76.4119L1253.52 55.9512ZM1253.69 164.358L1251.69 59.0528L1216.89 77.2623L1253.69 164.358Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1257 163.657C1257.93 165.833 1256.9 168.334 1254.72 169.26C1252.54 170.185 1250.04 169.16 1249.11 166.984C1248.19 164.808 1249.21 162.306 1251.39 161.381C1253.57 160.455 1256.1 161.481 1257 163.657Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1250.36 165.057C1250.41 167.409 1252.37 169.285 1254.72 169.235C1257.07 169.185 1258.95 167.234 1258.9 164.882C1258.85 162.531 1256.9 160.655 1254.54 160.705C1252.22 160.755 1250.34 162.706 1250.36 165.057Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1289.84 -106.51L1288.42 21.1072L1286.51 21.0822L1287.74 -89.1757L1254.22 54.6999L1283.79 27.2355L1285.09 28.6112L1250.96 60.3028L1289.84 -106.51Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1287.19 31.1871C1288.92 29.5863 1289.02 26.8849 1287.42 25.159C1285.81 23.4331 1283.11 23.333 1281.38 24.9338C1279.66 26.5347 1279.56 29.2361 1281.16 30.962C1282.76 32.7129 1285.46 32.788 1287.19 31.1871Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M1288.79 -93.6771L1253.42 58.1276L1213.76 78.8885L1214.79 76.4622L1286.34 -94.4775L1287.51 -93.9773L1288.79 -93.6771ZM1251.76 56.8519L1285.31 -87.0737L1217.57 74.7613L1251.76 56.8519Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1409.51 29.5117L1419.65 159.53L1418.72 159.63L1314.78 168.785L1314.63 166.884L1417.62 157.829L1408.01 34.8145L1313.8 165.458L1312.25 164.332L1409.51 29.5117Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1315.28 172.061C1312.93 172.261 1310.85 170.535 1310.65 168.184C1310.45 165.833 1312.18 163.757 1314.53 163.557C1316.88 163.357 1318.96 165.083 1319.16 167.434C1319.36 169.785 1317.63 171.861 1315.28 172.061Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1309.7 162.231C1308.32 164.132 1308.75 166.809 1310.67 168.185C1312.58 169.56 1315.25 169.135 1316.63 167.209C1318.01 165.308 1317.58 162.632 1315.66 161.256C1313.73 159.88 1311.07 160.305 1309.7 162.231Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1421 157.528L1314.63 166.883L1314.78 168.784L1411.29 160.28L1335.46 187.144L1314.4 170.01L1313.2 171.486L1335.08 189.27L1421 158.854V157.528Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1315.28 172.061C1312.93 172.261 1310.85 170.535 1310.65 168.184C1310.45 165.833 1312.18 163.757 1314.53 163.557C1316.88 163.357 1318.96 165.083 1319.16 167.434C1319.36 169.785 1317.63 171.861 1315.28 172.061Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1316.66 167.559C1314.83 166.058 1312.12 166.358 1310.65 168.184C1309.15 170.01 1309.45 172.711 1311.27 174.187C1313.1 175.688 1315.8 175.388 1317.28 173.562C1318.78 171.761 1318.51 169.059 1316.66 167.559Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1316.63 167.209C1315.26 169.11 1312.58 169.56 1310.67 168.184C1308.77 166.809 1308.32 164.132 1309.7 162.231C1311.07 160.33 1313.75 159.88 1315.66 161.256C1317.56 162.631 1318.01 165.308 1316.63 167.209Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1304.69 169.16C1306.59 170.536 1309.27 170.111 1310.65 168.185C1312.02 166.259 1311.6 163.607 1309.67 162.232C1307.77 160.856 1305.09 161.281 1303.71 163.207C1302.34 165.108 1302.76 167.784 1304.69 169.16Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1215.54 74.085L1216.54 76.4612L1254.02 165.158L1252.27 165.883L1215.79 79.5878L1171.66 220.862L1250.79 170.636L1251.82 172.236L1168.3 225.214L1215.54 74.085Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1257 163.657C1257.93 165.833 1256.9 168.334 1254.72 169.26C1252.54 170.185 1250.04 169.16 1249.11 166.984C1248.19 164.808 1249.21 162.306 1251.39 161.381C1253.57 160.455 1256.1 161.481 1257 163.657Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1253.42 175.138C1255.42 173.863 1256 171.236 1254.75 169.235C1253.47 167.234 1250.84 166.659 1248.84 167.91C1246.84 169.185 1246.26 171.812 1247.51 173.813C1248.79 175.814 1251.42 176.414 1253.42 175.138Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1217.77 73.2842L1172.08 219.461L1170.28 218.886L1213.56 80.3879L1107.52 190.446L1166.77 220.361L1165.92 222.062L1104.39 190.996L1105.26 190.07L1217.77 73.2842Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M1175.33 220.237C1174.63 222.488 1172.23 223.739 1169.98 223.038C1167.72 222.338 1166.47 219.937 1167.17 217.685C1167.87 215.434 1170.28 214.184 1172.53 214.884C1174.78 215.584 1176.04 217.986 1175.33 220.237Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1164.22 224.914C1166.32 225.99 1168.9 225.139 1169.95 223.038C1171 220.937 1170.18 218.361 1168.07 217.31C1165.97 216.235 1163.39 217.085 1162.34 219.186C1161.27 221.287 1162.12 223.864 1164.22 224.914Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M350.039 418.016L279.316 384.423L392.523 288.247L399.082 418.016H400.459L393.825 286.797L393.75 285.421L277.614 384.048L276.812 384.748L346.835 418.016H350.039Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M390.171 287.272L390.597 288.348L391.348 289.223L277.415 385.999L275.812 332.946L390.171 287.272ZM278.691 383.123L389.495 288.998L277.189 333.872L278.691 383.123Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M389.145 285.121C390.722 284.496 392.524 285.246 393.15 286.847C393.776 288.423 393.025 290.224 391.423 290.849C389.846 291.475 388.043 290.724 387.417 289.123C386.791 287.522 387.542 285.746 389.145 285.121Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M392.799 291.175C394.101 290.074 394.251 288.123 393.149 286.823C392.048 285.522 390.095 285.372 388.793 286.472C387.491 287.573 387.341 289.524 388.443 290.825C389.544 292.125 391.497 292.275 392.799 291.175Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M95.2602 177.766L65.1935 295.878L20.4314 279.669L20.9071 278.368L64.2422 294.077L92.3061 183.744L20.2562 276.117L19.1797 275.292L95.2602 177.766Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M22.2339 277.492C21.1824 278.843 19.2547 279.068 17.9028 278.017C16.551 276.967 16.3257 275.041 17.3771 273.69C18.4286 272.339 20.3562 272.114 21.7081 273.165C23.06 274.215 23.2853 276.141 22.2339 277.492Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M21.8594 276.166C20.2572 275.591 18.4797 276.417 17.9039 278.017C17.3281 279.618 18.1542 281.394 19.7565 281.97C21.3587 282.545 23.1362 281.719 23.712 280.119C24.2878 278.518 23.4616 276.742 21.8594 276.166Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M94.8859 180.466L94.3351 181.167L20.2574 276.117L19.1809 275.291L92.7079 181.042L28.5439 154.428L18.8304 275.166L17.4785 275.041L27.3422 152.427L28.1934 152.802L94.8859 180.466Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M21.2336 275.191C21.1084 276.892 19.6063 278.142 17.904 278.017C16.2016 277.892 14.9499 276.391 15.075 274.691C15.2002 272.99 16.7023 271.739 18.4046 271.864C20.107 272.014 21.3838 273.49 21.2336 275.191Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M17.3772 273.69C16.3258 275.041 16.5761 276.967 17.903 278.017C19.2548 279.068 21.1825 278.818 22.234 277.492C23.2854 276.141 23.0351 274.215 21.7082 273.165C20.3564 272.114 18.4287 272.364 17.3772 273.69Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M78.613 157.179L95.6366 182.242L24.1875 152.602L73.5059 154.352L73.4558 155.728L31.6979 154.252L91.9315 179.241L77.4864 157.954L78.613 157.179Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M73.4308 151.952C75.1331 152.002 76.46 153.427 76.4099 155.128C76.3598 156.829 74.9078 158.155 73.2305 158.105C71.5281 158.055 70.2013 156.629 70.2514 154.928C70.3014 153.227 71.7284 151.902 73.4308 151.952Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M80.692 155.953C79.7407 154.552 77.813 154.177 76.4111 155.127C75.0091 156.078 74.6336 158.004 75.5849 159.405C76.5362 160.805 78.4639 161.181 79.8658 160.23C81.2678 159.28 81.6433 157.379 80.692 155.953Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M278.065 333.647L120.947 383.523L120.521 382.222L274.96 333.197L135.617 238.597L118.969 380.922L117.617 380.772L134.541 236.221L278.065 333.647Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M270.505 192.097L277.264 334.747L276.138 333.997L133.59 237.221L266.699 189.546L267.15 190.847L136.569 237.596L275.762 332.096L269.128 192.172L270.505 192.097Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M265.747 187.345C267.349 186.77 269.127 187.595 269.702 189.196C270.278 190.797 269.452 192.573 267.85 193.123C266.248 193.698 264.47 192.873 263.919 191.272C263.293 189.696 264.145 187.92 265.747 187.345Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M272.908 192.147C272.833 190.447 271.381 189.146 269.678 189.221C267.976 189.296 266.674 190.747 266.749 192.448C266.824 194.148 268.276 195.449 269.979 195.374C271.681 195.299 272.983 193.848 272.908 192.147Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M135.967 235.82L135.767 237.496L118.393 385.824L65.6445 297.828L66.8212 297.127L117.491 381.672L134.215 239.022L67.422 293.651L66.5708 292.575L135.967 235.82Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.0743 295.401C67.7475 296.477 65.8198 296.277 64.7433 294.976C63.6668 293.651 63.8671 291.725 65.1689 290.649C66.4707 289.573 68.4234 289.773 69.4999 291.074C70.5764 292.375 70.3761 294.326 69.0743 295.401Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M68.9505 296.027C68.0743 294.576 66.1717 294.101 64.7196 294.976C63.2676 295.852 62.792 297.753 63.6682 299.204C64.5444 300.654 66.447 301.13 67.899 300.254C69.3511 299.379 69.8267 297.478 68.9505 296.027Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M93.4828 179.165L136.017 237.521L67.4216 293.65L66.5704 292.575L134.139 237.296L94.0836 182.317L66.1198 292.299L64.793 291.974L93.4828 179.165Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.4758 292.75C68.0502 294.401 66.3729 295.402 64.7206 294.976C63.0683 294.551 62.0669 292.875 62.4925 291.224C62.9181 289.574 64.5954 288.573 66.2477 288.998C67.9 289.423 68.9014 291.099 68.4758 292.75Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M65.1691 290.625C63.8423 291.7 63.667 293.651 64.7435 294.952C65.82 296.278 67.7727 296.453 69.0745 295.377C70.4014 294.301 70.5766 292.35 69.5001 291.05C68.4236 289.749 66.4709 289.549 65.1691 290.625Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M128.606 40.0182C130.159 39.2928 131.986 39.9681 132.712 41.5189C133.438 43.0697 132.762 44.8957 131.21 45.6211C129.658 46.3465 127.83 45.6711 127.104 44.1203C126.378 42.5695 127.054 40.7435 128.606 40.0182Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M129.783 44.77C131.486 44.6699 132.788 43.2192 132.687 41.5183C132.587 39.8174 131.135 38.5167 129.433 38.6167C127.731 38.7168 126.429 40.1675 126.529 41.8684C126.629 43.5443 128.081 44.845 129.783 44.77Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M335.644 199.552C334.743 198.101 335.194 196.2 336.646 195.324C338.098 194.424 340 194.874 340.876 196.325C341.778 197.776 341.327 199.677 339.875 200.552C338.448 201.453 336.545 201.002 335.644 199.552Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M338.249 199.376C338.925 197.825 338.224 195.999 336.646 195.324C335.094 194.649 333.267 195.349 332.591 196.925C331.915 198.476 332.616 200.302 334.193 200.977C335.77 201.652 337.573 200.927 338.249 199.376Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M372.069 212.859L372.144 213.134L395.226 291.525L337.621 198.176L338.773 197.451L391.045 282.12L370.917 213.809L338.948 197.275L339.574 196.05L372.069 212.859Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M335.644 199.552C334.743 198.101 335.194 196.2 336.646 195.324C338.098 194.424 340 194.874 340.876 196.325C341.778 197.776 341.327 199.677 339.875 200.552C338.448 201.453 336.545 201.002 335.644 199.552Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M340.826 193.998C339.324 193.223 337.447 193.798 336.67 195.324C335.894 196.825 336.47 198.701 337.997 199.476C339.499 200.252 341.377 199.676 342.153 198.15C342.929 196.625 342.328 194.774 340.826 193.998Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M333.816 194.374L333.691 195.725L270.403 189.971L277.062 330.47L334.868 197.726L336.119 198.276L275.961 336.373L268.951 188.471L333.816 194.374Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M332.591 196.9C333.267 195.349 335.095 194.623 336.647 195.299C338.199 195.974 338.925 197.8 338.249 199.351C337.573 200.902 335.745 201.627 334.193 200.952C332.641 200.276 331.915 198.476 332.591 196.9Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M333.317 198.1C335.019 198.25 336.521 197 336.671 195.324C336.822 193.623 335.57 192.122 333.893 191.972C332.19 191.822 330.688 193.073 330.538 194.749C330.363 196.45 331.614 197.95 333.317 198.1Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M119.371 190.071L119.471 190.371L134.767 234.419L133.715 234.794L132.814 235.445L91.8574 179.24L119.371 190.071ZM132.939 233.294L118.294 191.096L95.7378 182.242L132.939 233.294Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M135.766 233.094C136.768 234.47 136.467 236.396 135.091 237.396C133.714 238.397 131.786 238.097 130.785 236.721C129.783 235.345 130.084 233.419 131.461 232.419C132.837 231.418 134.765 231.718 135.766 233.094Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M131.162 235.52C131.712 237.121 133.465 237.972 135.092 237.421C136.694 236.871 137.546 235.12 136.995 233.494C136.444 231.893 134.692 231.043 133.064 231.593C131.462 232.144 130.611 233.894 131.162 235.52Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M267.35 187.319L266.749 188.545L238.159 174.713L141 234.569L266.699 189.545L267.15 190.846L129.158 240.247L238.084 173.137L267.35 187.319Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M265.747 187.345C267.349 186.77 269.127 187.595 269.702 189.196C270.278 190.797 269.452 192.573 267.85 193.123C266.248 193.698 264.47 192.873 263.919 191.272C263.293 189.696 264.145 187.92 265.747 187.345Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M265.574 190.647C267.101 191.397 268.954 190.747 269.705 189.221C270.456 187.695 269.805 185.844 268.278 185.094C266.751 184.343 264.898 184.994 264.147 186.519C263.396 188.045 264.022 189.896 265.574 190.647Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M240.062 173.537L238.485 174.513L135.442 237.996L134.641 236.896L210.946 171.461L211.848 172.487L142.126 232.268L236.181 174.313L216.404 171.211L216.629 169.86L240.062 173.537Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M209.269 169.735C210.57 168.635 212.498 168.785 213.625 170.061C214.726 171.361 214.576 173.287 213.299 174.413C211.997 175.513 210.07 175.363 208.943 174.088C207.842 172.787 207.992 170.836 209.269 169.735Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M217.157 167.509C215.479 167.234 213.902 168.385 213.627 170.086C213.351 171.762 214.503 173.337 216.205 173.613C217.883 173.888 219.46 172.737 219.735 171.036C219.985 169.36 218.834 167.76 217.157 167.509Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M-21 138.795L24.9387 153.202L25.3393 151.902L-21 137.369V138.795Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M-15.1919 71.9092L-21 74.7357V76.2365L-15.7928 73.7101L25.9401 151.176L27.1418 150.525L-15.1919 71.9092Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M29.1943 149.25C29.9954 150.751 29.4446 152.627 27.9426 153.428C26.4405 154.228 24.5629 153.678 23.7618 152.177C22.9606 150.676 23.5114 148.8 25.0135 148C26.5156 147.199 28.3932 147.75 29.1943 149.25Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M24.0625 155.454C25.6898 155.954 27.4172 155.053 27.9179 153.428C28.4186 151.802 27.5173 150.076 25.8901 149.576C24.2628 149.075 22.5354 149.976 22.0347 151.602C21.534 153.203 22.4353 154.928 24.0625 155.454Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M25.3393 151.902L-21 137.369V138.795L24.2628 152.977L-21 156.004V157.38L25.0639 154.303L24.9888 153.077L25.3393 151.902Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M24.6647 150.55C26.367 150.425 27.8441 151.726 27.9442 153.427C28.0694 155.128 26.7676 156.603 25.0652 156.704C23.3629 156.829 21.8858 155.528 21.7857 153.827C21.6605 152.151 22.9623 150.675 24.6647 150.55Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M24.0625 155.454C25.6898 155.954 27.4172 155.053 27.9179 153.428C28.4186 151.802 27.5173 150.076 25.8901 149.576C24.2628 149.075 22.5354 149.976 22.0347 151.602C21.534 153.203 22.4353 154.928 24.0625 155.454Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M-21 202.252V204.203L27.1167 155.253L17.4784 275.04L18.8302 275.165L28.769 151.601L-21 202.252Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M-21 249.677L15.1752 276.817L15.9763 275.716L-21 247.977V249.677Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M21.2336 275.191C21.1084 276.892 19.6063 278.142 17.904 278.017C16.2016 277.892 14.9499 276.391 15.075 274.691C15.2002 272.99 16.7023 271.739 18.4046 271.864C20.107 272.014 21.3838 273.49 21.2336 275.191Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M13.5987 278.644C14.9506 279.669 16.9033 279.394 17.9047 278.018C18.9311 276.668 18.6557 274.717 17.2788 273.716C15.9269 272.69 13.9742 272.966 12.9728 274.341C11.9714 275.692 12.2468 277.618 13.5987 278.644Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M-21 156.004V157.379L26.1905 154.228L-21 202.253V204.204L29.6953 152.627L-21 156.004Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M61.1142 74.7366L60.8389 75.3869L29.6957 150.977L28.4189 150.451L59.3117 75.537L14.2492 59.2034L28.1685 150.426L26.8167 150.626L12.5469 57.1523L61.1142 74.7366Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M31.9736 151.752C31.3227 153.327 29.5202 154.078 27.943 153.427C26.3658 152.777 25.6148 150.976 26.2657 149.4C26.9166 147.825 28.7191 147.074 30.2963 147.724C31.8484 148.375 32.5995 150.176 31.9736 151.752Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.4131 150.85C24.6634 152.526 26.2406 153.677 27.918 153.427C29.5953 153.177 30.7469 151.601 30.4965 149.925C30.2462 148.249 28.669 147.098 26.9917 147.349C25.3143 147.599 24.1627 149.175 24.4131 150.85Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.9241 57.1523L14.0743 58.0778L28.1689 150.426L26.9922 150.601L25.9408 151.177L-16.418 72.5354L13.9241 57.1523ZM26.6668 149.626L12.8727 59.2034L-14.5654 73.1107L26.6668 149.626Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M29.1943 149.25C29.9954 150.751 29.4446 152.627 27.9426 153.428C26.4405 154.228 24.5629 153.678 23.7618 152.177C22.9606 150.676 23.5114 148.8 25.0135 148C26.5156 147.199 28.3932 147.75 29.1943 149.25Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M24.4131 150.85C24.6634 152.526 26.2406 153.677 27.918 153.427C29.5953 153.177 30.7469 151.601 30.4965 149.925C30.2462 148.249 28.669 147.098 26.9917 147.349C25.3143 147.599 24.1627 149.175 24.4131 150.85Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M47.495 48.5715L61.5895 76.3611L11.4199 58.1766L42.5631 46.6455L43.0388 47.9212L15.3754 58.1766L58.8107 73.9098L46.2683 49.1718L47.495 48.5715Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M41.586 44.4451C43.1883 43.8448 44.9657 44.6703 45.5415 46.2711C46.1424 47.872 45.3162 49.6479 43.714 50.2232C42.1118 50.8235 40.3343 49.9981 39.7585 48.3972C39.1827 46.8214 39.9838 45.0455 41.586 44.4451Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M49.6981 47.622C48.922 46.0962 47.0695 45.4958 45.5424 46.2712C44.0152 47.0467 43.4144 48.8976 44.1905 50.4234C44.9666 51.9492 46.8191 52.5495 48.3463 51.7741C49.8483 50.9987 50.4742 49.1227 49.6981 47.622Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M20.1589 -18.2637L46.4453 46.6454L12.6484 59.177L12.7235 58.1264L17.5803 -17.8385L18.9322 -17.7634L20.1589 -18.2637ZM44.6428 45.87L18.9322 -17.6884L14.1505 57.1759L44.6428 45.87Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M-21 33.5391V35.2149L12.0709 58.0769L-13.1892 70.8837L-12.5633 72.1093L14.7246 58.2771L-21 33.5391Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M17.5535 -17.8379L12.7969 56.9264L-21 33.5391V35.19L13.9985 59.4277L18.9304 -17.7378L17.5535 -17.8379Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M78.8636 105.102L77.1863 152.251L75.8344 152.201L77.3865 108.353L29.6203 152.802L73.5061 154.352L73.4561 155.728L26.2656 154.052L78.8636 105.102Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M73.4308 151.952C75.1331 152.002 76.46 153.427 76.4099 155.128C76.3598 156.829 74.9078 158.155 73.2305 158.105C71.5281 158.055 70.2013 156.629 70.2514 154.928C70.3014 153.227 71.7284 151.902 73.4308 151.952Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.4311 151.952C73.381 153.652 74.7078 155.078 76.4102 155.128C78.1125 155.178 79.5395 153.853 79.5896 152.152C79.6397 150.451 78.3128 149.025 76.6105 148.975C74.9331 148.925 73.4811 150.251 73.4311 151.952Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M129.759 42.1191L130.31 43.3448L131.336 44.1952L78.0124 107.904L59.2363 74.8113L59.9123 74.4861L129.759 42.1191ZM78.2377 105.527L130.21 43.4198L61.164 75.4366L78.2377 105.527Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M128.606 40.0182C130.159 39.2928 131.986 39.9681 132.712 41.5189C133.438 43.0697 132.762 44.8957 131.21 45.6211C129.658 46.3465 127.83 45.6711 127.104 44.1203C126.378 42.5695 127.054 40.7435 128.606 40.0182Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M133.088 45.8455C134.189 44.5448 134.014 42.5938 132.712 41.4932C131.41 40.3926 129.458 40.5677 128.356 41.8684C127.255 43.1691 127.43 45.1201 128.732 46.2207C130.033 47.3463 131.986 47.1712 133.088 45.8455Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M60.1119 73.5596L78.9881 106.852L30.5459 151.926L29.6447 150.95L28.418 150.45L60.1119 73.5596ZM77.2607 106.577L60.2872 76.6862L29.7448 150.8L77.2607 106.577Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M31.9736 151.752C31.3227 153.327 29.5202 154.078 27.943 153.427C26.3658 152.777 25.6148 150.976 26.2657 149.4C26.9166 147.825 28.7191 147.074 30.2963 147.724C31.8484 148.375 32.5995 150.176 31.9736 151.752Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M28.0932 149.074C26.8414 150.225 26.7663 152.176 27.943 153.426C29.0946 154.677 31.0473 154.752 32.299 153.576C33.5507 152.426 33.6258 150.475 32.4492 149.224C31.2976 147.973 29.3449 147.923 28.0932 149.074Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M400.459 418.016L394.025 290.899L438.988 403.208L424.493 418.016H426.42L440.265 403.833L440.565 403.508L392.248 282.77L399.083 418.016H400.459Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M420.062 292.45L469.005 349.43L468.804 349.855L439.489 405.384L417.533 293.676L418.885 293.426L440.064 401.332L467.377 349.63L419.035 293.351L420.062 292.45Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M415.204 294.301C414.879 292.625 415.956 291.024 417.633 290.674C419.31 290.349 420.912 291.425 421.263 293.1C421.588 294.776 420.512 296.377 418.834 296.727C417.157 297.052 415.53 295.952 415.204 294.301Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M421.989 290.999C420.887 289.698 418.935 289.548 417.633 290.674C416.331 291.775 416.181 293.726 417.307 295.026C418.409 296.327 420.362 296.477 421.663 295.351C422.94 294.251 423.09 292.3 421.989 290.999Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M414.854 289.549L414.628 290.899L394.225 287.698L437.685 396.33L417.532 293.676L418.884 293.426L440.439 403.233L439.137 403.608L392.047 285.972L414.854 289.549Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M415.08 287.147C416.757 287.423 417.909 288.998 417.658 290.674C417.383 292.35 415.806 293.501 414.128 293.251C412.451 292.975 411.299 291.4 411.55 289.724C411.825 288.048 413.402 286.897 415.08 287.147Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M421.263 293.1C420.937 291.425 419.31 290.349 417.633 290.674C415.956 290.999 414.879 292.625 415.204 294.301C415.53 295.977 417.157 297.052 418.834 296.727C420.512 296.402 421.588 294.776 421.263 293.1Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M210.722 169.235L210.647 170.611L150.463 167.409L136.168 235.57L210.947 171.461L211.848 172.487L133.99 239.247L149.362 165.983L210.722 169.235Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M209.269 169.735C210.57 168.635 212.498 168.785 213.625 170.061C214.726 171.361 214.576 173.287 213.299 174.413C211.997 175.513 210.07 175.363 208.943 174.088C207.842 172.787 207.992 170.836 209.269 169.735Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M210.37 172.987C212.073 173.087 213.525 171.761 213.625 170.085C213.725 168.409 212.398 166.933 210.721 166.833C209.018 166.733 207.566 168.059 207.466 169.735C207.366 171.436 208.668 172.887 210.37 172.987Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M204.013 146.349L214.678 170.811L213.577 170.761L146.984 167.235L199.282 144.473L199.808 145.723L152.843 166.159L212.55 169.336L202.762 146.899L204.013 146.349Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M198.179 142.345C199.732 141.67 201.559 142.37 202.235 143.946C202.911 145.497 202.21 147.323 200.633 147.998C199.081 148.674 197.253 147.973 196.577 146.398C195.901 144.822 196.602 143.021 198.179 142.345Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M206.29 145.523C205.614 143.972 203.786 143.247 202.234 143.922C200.682 144.597 199.956 146.423 200.632 147.974C201.308 149.525 203.136 150.25 204.688 149.575C206.24 148.9 206.966 147.099 206.29 145.523Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.963 165.033L136.343 234.695L135.016 234.395L148.86 168.36L119.62 190.822L134.766 234.42L133.464 234.87L118.018 190.346L118.418 190.046L150.963 165.033Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M136.995 233.494C137.546 235.095 136.694 236.846 135.092 237.421C133.49 237.972 131.738 237.121 131.162 235.52C130.611 233.919 131.462 232.169 133.064 231.593C134.667 231.043 136.419 231.893 136.995 233.494Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M132.687 233.769C132.337 235.445 133.413 237.071 135.066 237.421C136.743 237.771 138.37 236.696 138.721 235.045C139.071 233.369 137.995 231.743 136.342 231.393C134.69 231.018 133.038 232.093 132.687 233.769Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M134.916 43.5449L203.26 144.223L202.509 144.548L149.361 167.685L149.235 166.785L132.412 44.5205L133.764 44.3203L150.462 165.709L201.208 143.647L133.764 44.3203L134.916 43.5449Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M130.059 44.9947C129.834 43.3188 131.01 41.743 132.688 41.5179C134.365 41.2927 135.942 42.4684 136.167 44.1442C136.393 45.8201 135.216 47.3959 133.539 47.6211C131.836 47.8462 130.284 46.6706 130.059 44.9947Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M136.969 42.3435C136.018 40.9428 134.09 40.5676 132.688 41.518C131.286 42.4685 130.911 44.3946 131.862 45.7953C132.814 47.196 134.741 47.5712 136.143 46.6207C137.57 45.6702 137.946 43.7442 136.969 42.3435Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M152.917 165.233L121.573 189.346L120.722 188.27L146.883 168.16L96.0128 180.892L116.341 188.871L115.84 190.146L91.5566 180.616L152.917 165.233Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M117.091 186.595C118.669 187.22 119.445 188.996 118.844 190.597C118.218 192.173 116.441 192.949 114.838 192.348C113.261 191.723 112.485 189.947 113.086 188.346C113.712 186.745 115.489 185.97 117.091 186.595Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M119.396 186.269C118.044 187.294 117.794 189.245 118.82 190.596C119.847 191.947 121.799 192.197 123.151 191.171C124.503 190.146 124.753 188.195 123.727 186.844C122.701 185.493 120.748 185.218 119.396 186.269Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M153.343 166.559L96.7893 180.691L96.4638 179.366L146.483 166.859L77.863 156.054L92.7086 177.94L91.582 178.715L74.959 154.228L153.343 166.559Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M94.61 176.465C95.5613 177.865 95.2108 179.791 93.7838 180.742C92.3819 181.692 90.4542 181.342 89.5029 179.916C88.5516 178.516 88.9271 176.59 90.329 175.639C91.731 174.689 93.6586 175.064 94.61 176.465Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M96.0386 177.014C94.3863 177.439 93.3849 179.09 93.7854 180.741C94.211 182.392 95.8633 183.392 97.5156 182.992C99.1679 182.567 100.169 180.916 99.7687 179.265C99.3682 177.589 97.6908 176.589 96.0386 177.014Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M152.24 167.76L79.1886 156.279L79.414 154.928L147.583 165.633L78.763 108.128L77.1859 152.251L75.834 152.201L77.4863 105.302L152.24 167.76Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M79.5896 152.176C79.5395 153.877 78.0875 155.203 76.4102 155.153C74.7078 155.103 73.381 153.677 73.4311 151.976C73.4811 150.275 74.9081 148.949 76.6105 148.999C78.3128 149.049 79.6647 150.475 79.5896 152.176Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M79.9397 152.576C78.2624 152.301 76.6852 153.451 76.4098 155.152C76.1344 156.828 77.286 158.404 78.9884 158.679C80.6657 158.954 82.2429 157.804 82.5183 156.103C82.7686 154.427 81.617 152.851 79.9397 152.576Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M133.766 44.3199L150.839 168.36L77.1621 106.803L130.286 43.3193L131.337 44.1948L79.0898 106.628L148.987 165.033L132.414 44.52L133.766 44.3199Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M130.059 44.9947C129.834 43.3188 131.01 41.743 132.688 41.5179C134.365 41.2927 135.942 42.4684 136.167 44.1442C136.393 45.8201 135.216 47.3959 133.539 47.6211C131.836 47.8462 130.284 46.6706 130.059 44.9947Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M133.088 45.8455C134.189 44.5448 134.014 42.5938 132.712 41.4932C131.41 40.3926 129.458 40.5677 128.356 41.8684C127.255 43.1691 127.43 45.1201 128.732 46.2207C130.033 47.3463 131.986 47.1712 133.088 45.8455Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M51.6007 178.765L50.7746 177.039L-21 317.363V321.54L50.7245 181.316L141.4 371.641L143.103 370.841L51.6007 178.765Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M-21 250.603L47.2697 183.893L-21 317.363V321.54L49.7481 183.218L48.3211 182.492L47.1946 181.342L-21 247.952V250.603Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M44.7157 179.116C46.3931 177.465 49.1219 177.49 50.7491 179.191C52.4014 180.867 52.3764 183.594 50.674 185.219C48.9967 186.87 46.2679 186.845 44.6406 185.144C42.9884 183.468 43.0134 180.767 44.7157 179.116Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M52.6021 184.919C53.6786 182.818 52.8525 180.242 50.7496 179.166C48.6467 178.09 46.0681 178.916 44.9916 181.017C43.9151 183.118 44.7412 185.694 46.8442 186.77C48.9721 187.846 51.5257 187.02 52.6021 184.919Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M-21 97.1471L-16.5689 97.5223L45.5673 174.288L-21 126.362V128.689L55.9317 184.093L-15.3672 95.9965L-15.6175 95.6963L-21 95.2461V97.1471Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M184.135 220.963L238.485 255.706L171.342 305.582L178.877 223.514L180.78 223.689L173.62 301.53L235.155 255.806L183.108 222.539L184.135 220.963Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M175.547 223.439C175.772 221.088 177.85 219.362 180.203 219.587C182.557 219.812 184.284 221.888 184.059 224.24C183.833 226.591 181.755 228.317 179.402 228.092C177.074 227.866 175.322 225.765 175.547 223.439Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M186.112 218.261C184.134 216.985 181.481 217.561 180.204 219.562C178.927 221.538 179.503 224.189 181.506 225.465C183.483 226.74 186.137 226.165 187.414 224.164C188.666 222.188 188.09 219.537 186.112 218.261Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M47.4453 174.463L173.595 303.331L173.37 303.906L146.383 371.491L144.63 370.791L171.367 303.781L54.0545 183.918L143.103 370.841L141.401 371.641L47.4453 174.463Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M88.2267 172.062L181.206 219.011L181.131 219.662L173.169 306.307L85.623 174.988L87.2002 173.938L171.768 300.804L179.203 220.112L87.3504 173.762L88.2267 172.062Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M82.9686 177.014C81.6668 175.063 82.1926 172.412 84.1453 171.086C86.098 169.786 88.7517 170.311 90.0785 172.262C91.3803 174.213 90.8546 176.864 88.9019 178.19C86.9492 179.516 84.2955 178.965 82.9686 177.014Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M89.9048 169.211C87.8019 168.135 85.2233 168.985 84.1719 171.087C83.0954 173.188 83.9465 175.764 86.0495 176.815C88.1524 177.89 90.731 177.04 91.7824 174.939C92.8589 172.837 92.0077 170.261 89.9048 169.211Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M79.9916 171.136L80.4422 172.962L52.6036 179.715L166.086 295.676L85.6244 174.988L87.2016 173.937L173.271 303.03L171.794 304.231L48.8984 178.64L79.9916 171.136Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M79.0143 167.934C81.3174 167.384 83.6206 168.784 84.1714 171.086C84.7222 173.387 83.3202 175.688 81.017 176.238C78.7138 176.789 76.4106 175.388 75.8599 173.087C75.3091 170.81 76.7111 168.509 79.0143 167.934Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M90.0778 172.286C88.776 170.335 86.1223 169.785 84.1446 171.111C82.1919 172.412 81.6411 175.063 82.9679 177.039C84.2697 178.99 86.9234 179.54 88.9012 178.215C90.8539 176.889 91.4046 174.238 90.0778 172.286Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M240.413 257.882L314.891 329.494L188.391 347.279L234.129 258.932L235.806 259.783L191.745 344.877L310.76 328.169L239.111 259.258L240.413 257.882Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M231.073 257.582C232.15 255.481 234.728 254.655 236.831 255.756C238.934 256.831 239.76 259.408 238.659 261.509C237.582 263.61 235.004 264.435 232.901 263.335C230.798 262.259 229.997 259.683 231.073 257.582Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M242.865 255.631C241.162 254.005 238.459 254.055 236.831 255.756C235.204 257.457 235.254 260.159 236.957 261.784C238.659 263.41 241.363 263.36 242.99 261.659C244.617 259.983 244.567 257.282 242.865 255.631Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M233.004 257.407L234.13 258.933L235.808 259.809L189.969 348.33L171.318 303.256L171.919 302.806L233.004 257.407ZM190.17 343.828L234.105 258.958L173.647 303.882L190.17 343.828Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M230.849 254.881C232.751 253.48 235.43 253.855 236.832 255.756C238.234 257.657 237.833 260.334 235.956 261.734C234.053 263.135 231.374 262.76 229.972 260.859C228.57 258.958 228.946 256.281 230.849 254.881Z",
    fill: "#00A873"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M238.659 261.509C239.735 259.408 238.909 256.832 236.831 255.756C234.728 254.681 232.15 255.481 231.073 257.582C229.997 259.683 230.798 262.26 232.901 263.335C235.004 264.411 237.582 263.61 238.659 261.509Z",
    fill: "#00A873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3651_16080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.92718 755.056) scale(1116.9 1115.94)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00907D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0406,
    stopColor: "#008372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#005B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3368,
    stopColor: "#003A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4904,
    stopColor: "#00211C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6487,
    stopColor: "#000E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8145,
    stopColor: "#000403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3651_16080",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1103.79 -385.322) scale(1107.07 1106.12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1309,
    stopColor: "#005B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2902,
    stopColor: "#003A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4546,
    stopColor: "#00211B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#000E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8014,
    stopColor: "#000403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_16080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 300,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBg);
export default __webpack_public_path__ + "static/media/profile-bg.80a285b59cedae5f0b3d29be4d0c08b9.svg";
export { ForwardRef as ReactComponent };